import React, { useEffect, useState } from "react";
import {
  deleteFaQs,
  editFAQ,
  getFaQs,
} from "../../services/Admin/adminServices";
import { Modal, Button, Form } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Spinner from "../components/Common/Spinner";
import Pagination from "../components/Pagination";
import { debounce } from "lodash";

const UnEnroll = () => {
  const [faq, setFaq] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
   const [currentPage, setCurrentPage] = useState(0);
  const [selectedFaq, setSelectedFaq] = useState(null);
      const [itemsPerPage, setItemsPerPage] = useState(10);
            const [totalItems, setTotalItems] = useState(0);
            const [search, setSearch] = useState("");
             const [debouncedSearch, setDebouncedSearch] = useState("");
  const navigate = useNavigate();

  const getFAQS = async () => {
    try {
      setLoading(true);
      const response = await getFaQs(currentPage+1, 10,debouncedSearch);
      setFaq(response?.data?.data?.faqs);
              setTotalItems(response?.data?.data.count);
    } catch (error) {
      console.error("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFAQS();
  }, [currentPage,debouncedSearch]);

  // Delete FAQ
  const handleDelete = async (id,index) => {
    try {
      await deleteFaQs(id);
      setFaq((prev) => prev.filter((item) => item._id !== id));
       if (activeIndex === index) {
    setActiveIndex(null);
  } 
  // if the deleted item was before the active one, shift activeIndex by -1
  else if (activeIndex > index) {
    setActiveIndex(activeIndex - 1);
  }
  setTotalItems(prev => prev - 1);
      toast.success("Deleted SuccessFully");
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  const handleEdit = (item) => {
    setSelectedFaq(item);
    setShowModal(true);
  };

  const validationSchema = Yup.object().shape({
    question: Yup.string().required("Question is required"),
    answer: Yup.string().required("Answer is required"),
  });

  
   useEffect(() => {
    const handler = debounce(() => {
      setDebouncedSearch(search);
    }, 500); 
  
    handler();
  
    return () => {
      handler.cancel();
    };
  }, [search]);



  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await editFAQ(values);

      setShowModal(false);
      getFAQS();
      toast.success("Updated");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.error("error->", error);
    } finally {
      setSubmitting(false);
    }
  };
    const totalPages = Math.ceil(totalItems / itemsPerPage);
  return (
    <div >
        <h2 className="mb-3" style={{color:"#0AB7EA"}}>FAQs</h2>
      <div className="d-flex gap-3 mb-3">
       <div className="flex-grow-1 ">
    <input
      type="text"
      style={{ borderRadius: "0.5rem", borderColor: "#0AB7EA" }}
      className="form-control w-100"
      placeholder="Search....."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />
  </div>
        <div>
          <button
            className="btn"
            style={{
              backgroundColor: "#0AB7EA",
              color: "white",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
            }}
            onClick={() => navigate("/add-faq")}
          >
            Add new
          </button>
        </div>
      </div>

      {loading ? (
        // <div className="d-flex justify-content-center my-5">
        //   <Spinner animation="border" role="status" className="custom-spinner">
        //     <span className="visually-hidden">Loading...</span>
        //   </Spinner>
        // </div>
        <Spinner />
      ) : faq.length === 0 ? (
        <p>No FAQs available.</p>
      ) : (
        <div className="accordion">
          {faq.map((item, index) => (
            <div className="accordion-item" key={item._id || index}>
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${
                    activeIndex === index ? "" : "collapsed"
                  }`}
                  type="button"
                  onClick={() =>
                    setActiveIndex(activeIndex === index ? null : index)
                  }
                >
                  {item.question}
                </button>
              </h2>
              <div
                className={`accordion-collapse collapse ${
                  activeIndex === index ? "show" : ""
                }`}
              >
                <div className="accordion-body">
                  {item.answer}
                  <div className="mt-2">
                    <button
                      className="btn btn-sm  me-2"
                      style={{background:"#0AB7EA", color:"white"}}
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(item._id,index)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}


        <div className="card-footer clearfix">
                          <div className="d-flex justify-content-between align-items-center">
                            <div
                              className="dataTables_info"
                              style={{ color: "#0AB7EA" }}
                            >
                              Page {currentPage * itemsPerPage + 1} to{" "}
                              {totalItems > (currentPage + 1) * itemsPerPage
                                ? (currentPage + 1) * itemsPerPage
                                : totalItems}{" "}
                              of {totalItems} entries
                            </div>
                            <div
                              className="d-flex align-items-center"
                              style={{ gap: "10px" }}
                            >
                              <Pagination
                                pageCount={totalPages}
                                pageValue={currentPage}
                                setPage={setCurrentPage}
                              />
                            </div>
                          </div>
                        </div>

      {selectedFaq && (
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title className="titleColor">Edit FAQ</Modal.Title>
          </Modal.Header>
          <Formik
            enableReinitialize
            initialValues={{
              question: selectedFaq?.question || "",
              answer: selectedFaq?.answer || "",
              faqId: selectedFaq?._id || "",
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <FormikForm>
                <Modal.Body>
                  <Form.Group className="mb-3">
                    <Form.Label>Question</Form.Label>
                    <Field name="question" className="form-control" />
                    <div className="text-danger">
                      <ErrorMessage name="question" />
                    </div>
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Answer</Form.Label>
                    <Field
                      as="textarea"
                      name="answer"
                      className="form-control"
                      rows={3}
                    />
                    <div className="text-danger">
                      <ErrorMessage name="answer" />
                    </div>
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    style={{backgroundColor:"#0AB7EA",border:"none"}}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "updating":"Save Changes"
                    }
                  </Button>
                </Modal.Footer>
              </FormikForm>
            )}
          </Formik>
        </Modal>
      )}











      
    </div>




  );
};

export default UnEnroll;
